module.exports = __webpack_public_path__ + "img/active-bg.76cf76d1.svg";